import { Directive, TemplateRef } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[buttonContent]'
})
export class ButtonContentSlotDirective {
  constructor(public tpl: TemplateRef<any>) {}
}
